import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Document',
  'Due Date',
  'Assignee',
  'Department',
  'Location',
  'Manager'
];

const DocumentsReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report
        name={t('reports.DOCUMENTS')}
        url='/reports/documents'
      />
    </CompositeReport>
  );
};

export default DocumentsReport;
